import { Element, Node, Text } from 'slate'

import { TableAdapter } from '@makyoapp/makyo-common'

const findColumnName = (columnId: string, tables?: TableAdapter[]): string => {
  if (!tables || tables.length === 0) return columnId

  for (const table of tables) {
    const column = table.columns.find((c) => c.id === columnId)
    if (column) {
      return column.name
    }
  }
  return columnId
}

const extractFileName = (url: string): string => {
  try {
    const urlObj = new URL(url)
    const filename = urlObj.pathname.split('/').pop()
    return filename ? decodeURIComponent(filename) : url
  } catch (e) {
    const filename = url.split('/').pop()
    return filename ? decodeURIComponent(filename) : url
  }
}

const extractTextFromNodes = (nodes: Node[], tables?: TableAdapter[]): string => {
  let text = ''

  for (const node of nodes) {
    if (Text.isText(node)) {
      text += node.text || ''
    } else if (Element.isElement(node) && node.children) {
      if ('col' in node && node.col && typeof node.col === 'string') {
        text += findColumnName(node.col, tables)
      }

      if ('type' in node && node.type === 8 && 'value' in node && typeof node.value === 'string') {
        text += node.value
      }

      if ('type' in node && node.type === 16) {
        text += 'Page Name'
      }

      if ('type' in node && node.type === 1024) {
        text += 'Page Title'
      }

      if ('type' in node && node.type === 2048) {
        text += 'Page Subtitle'
      }

      if ('type' in node && node.type === 4096) {
        text += 'Page Description'
      }

      if ('type' in node && node.type === 524288) {
        text += 'Session ID'
      }

      if ('value' in node && typeof node.value === 'string' && !('col' in node)) {
        text += node.value
      }

      text += extractTextFromNodes(node.children, tables)
    }
  }

  return text
}

export const getTextFromSlateValue = (value: Node[] | string, tables?: TableAdapter[]): string => {
  if (!value) return ''

  try {
    if (typeof value === 'string') {
      if (!value.includes('[') && !value.includes('{')) {
        return value
      }

      try {
        const parsed = JSON.parse(value)
        if (Array.isArray(parsed)) {
          value = parsed
        } else {
          return value
        }
      } catch (e) {
        return value as string
      }
    }

    if (typeof value === 'object' && !Array.isArray(value) && 'col' in value) {
      const colValue = (value as any).col
      if (typeof colValue === 'string') {
        return findColumnName(colValue, tables)
      }
    }

    if (typeof value === 'object' && !Array.isArray(value) && 'flag' in value) {
      const obj = value as any
      if (obj.flag === 128 && 'value' in obj && typeof obj.value === 'string') {
        return extractFileName(obj.value)
      } else {
        return obj.value as string
      }
    }

    if (!Array.isArray(value) || value.length === 0) return ''

    return extractTextFromNodes(value, tables).trim()
  } catch (error) {
    console.error('Error extracting text from Slate value:', error)
    return ''
  }
}
